import React, { useEffect, useRef, useState } from "react";
import { X } from "lucide-react";
export default function FilterDrawer({
    isOpen,
    onClose,
    sections = [],
    tempValues,
    setTempValues,
    onApply,
    onClear,
    title = "Filter",
}) {
    const drawerRef = useRef(null);
    const dropdownRefs = useRef({});

    const [openDropdown, setOpenDropdown] = useState(null);
    useEffect(() => {
        function handleClickOutside(e) {
            if (!openDropdown) return;
            const dropdownEl = dropdownRefs.current[openDropdown];

            if (dropdownEl && !dropdownEl.contains(e.target)) {
                setOpenDropdown(null);

                // ⭐ CLEAR THE SEARCH TEXT WHEN DROPDOWN CLOSES
                setTempValues(prev => ({
                    ...prev,
                    [`${openDropdown}Search`]: "",
                }));
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [openDropdown]);



    const clearAllSearchFields = () => {
        const updated = { ...tempValues };

        sections.forEach(sec => {
            if (sec.type === "list") {
                updated[`${sec.key}Search`] = "";
            }
        });

        setTempValues(updated);
    };

    // do not render component if drawer is closed
    if (!isOpen) return null;


    // Close dropdown on outside click


    return (
        <>
            {/* Overlay */}
            <div
                onClick={() => {
                    clearAllSearchFields();
                    onClose();
                }}

                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(0,0,0,0.4)",
                    zIndex: 1999,
                }}
            />

            {/* Drawer */}
            <div
                ref={drawerRef}
                style={{
                    position: "fixed",
                    top: 0,
                    right: 0,
                    width: 360,
                    height: "100vh",
                    backgroundColor: "#fff",
                    boxShadow: "-3px 0 12px rgba(0,0,0,0.1)",
                    zIndex: 2000,
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {/* Header */}
                <div
                    style={{
                        display: "flex",
                        height: "60px",
                        justifyContent: "space-between",
                        alignItems: "center",
                        alignSelf: 'stretch',
                        padding: "15px 20px",
                        background: "#F8F9FA",
                    }}
                >
                    <h4 style={{ margin: 0, fontWeight: 600, color: ' #212529', fontFamily: 'Montserrat', fontSize: '14px', fontStyle: 'normal', lineHeight: 'normal' }}>{title}</h4>

                    <button
                        onClick={() => {
                            clearAllSearchFields();
                            onClose();
                        }}

                        style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            padding: '4px'
                        }}
                    >
                        <X size={18} />
                    </button>
                </div>

                {/* Body */}
                <div
                    style={{
                        flex: 1,
                        overflowY: "auto",
                        padding: "20px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        overflowX: "hidden"
                    }}
                >
                    {sections.map((section, index) => (
                        <div key={index}>

                            {/* Section Label */}
                            <label
                                style={{
                                    fontWeight: 600,
                                    marginBottom: '8px',
                                    color: '#212529',
                                    fontFamily: 'Montserrat',
                                    fontSize: '14px',
                                    fontStyle: 'normal',
                                    lineHeight: 'normal'
                                }}
                            >
                                {section.label}
                            </label>

                            {/* -------------------------------------- */}
                            {/* STATUS CHECKBOXES (Active / Inactive) */}
                            {/* -------------------------------------- */}
                            {section.type === "checkbox" && (
                                <div style={{ marginTop: 6 }}>
                                    {section.options.map((opt) => {
                                        const checked = (tempValues[section.key] || []).includes(opt);

                                        return (
                                            <label
                                                key={opt}
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "10px",
                                                    padding: "8px 0",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                <input
                                                    type="checkbox"
                                                    checked={checked}
                                                    onChange={() => {
                                                        const list = tempValues[section.key] || [];
                                                        const updated = checked
                                                            ? list.filter(x => x !== opt)
                                                            : [...list, opt];

                                                        setTempValues(prev => ({
                                                            ...prev,
                                                            [section.key]: updated
                                                        }));
                                                    }}
                                                    style={{ opacity: 0, position: "absolute" }}
                                                />

                                                <span
                                                    style={{
                                                        width: 18,
                                                        height: 18,
                                                        borderRadius: 4,
                                                        border: "1.5px solid #212529",
                                                        background: checked ? "#FFEB00" : "#fff",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                    }}
                                                >
                                                    {checked && (
                                                        <svg
                                                            width="12"
                                                            height="12"
                                                            viewBox="0 0 12 12"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            style={{ position: "absolute" }}
                                                        >
                                                            <path
                                                                d="M2 6L4.5 8.5L10 3"
                                                                stroke="#000"
                                                                strokeWidth="2"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                        </svg>
                                                    )}
                                                </span>

                                                <span style={{
                                                    fontFamily: "Montserrat",
                                                    fontSize: "14px",
                                                    fontStyle: "normal",
                                                    fontWeight: "400",
                                                    lineHeight: "18px",
                                                    color: "#212529"
                                                }}>{opt}</span>
                                            </label>
                                        );
                                    })}
                                </div>
                            )}

                            {/* ------------------------------------------------------- */}
                            {/* LIST TYPE (BRAND, CATEGORY, TYPE) with Chips + Search */}
                            {/* ------------------------------------------------------- */}

                            {section.type === "list" && (
                                <div style={{ position: "relative", marginTop: 6 }}>

                                    {/* FIXED POSITION WRAPPER */}
                                    <div style={{ position: "relative" }}>

                                        {/* CHIP + SEARCH INPUT */}
                                        <div
                                            style={{
                                                width: "100%",
                                                minHeight: "44px",
                                                borderRadius: "8px",
                                                border: "1px solid #212529",
                                                padding: "6px 10px",
                                                display: "flex",
                                                flexWrap: "wrap",
                                                alignItems: "center",
                                                gap: "6px",
                                                background: "#fff",
                                                cursor: "text",
                                            }}
                                            onClick={() => setOpenDropdown(section.key)}
                                        >
                                            {/* Chips */}
                                            {(tempValues[section.key] || []).map((id) => {
                                                const item = section.data.find(i => section.renderItem(i).id === id);
                                                if (!item) return null;

                                                const { title } = section.renderItem(item);

                                                return (
                                                    <span
                                                        key={id}
                                                        style={{
                                                            background: "#FFEB00",
                                                            color: "#212529",
                                                            borderRadius: "16px",
                                                            padding: "4px 10px",
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            fontSize: "12px",
                                                            fontWeight: "600",
                                                        }}
                                                    >
                                                        {title}
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                const updated = (tempValues[section.key] || []).filter(x => x !== id);

                                                                setTempValues(prev => ({
                                                                    ...prev,
                                                                    [section.key]: updated
                                                                }));
                                                            }}
                                                            style={{
                                                                background: "none",
                                                                border: "none",
                                                                marginLeft: 6,
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            <X size={14} strokeWidth={3} />
                                                        </button>
                                                    </span>
                                                );
                                            })}

                                            {/* Search Text Input */}
                                            <input
                                                type="text"
                                                value={tempValues[`${section.key}Search`] || ""}
                                                onChange={(e) => {
                                                    const val = e?.target?.value ?? ""; // safe
                                                    setTempValues(prev => ({
                                                        ...prev,
                                                        [`${section.key}Search`]: val,
                                                    }));
                                                    setOpenDropdown(section.key);
                                                }}
                                                placeholder={
                                                    (tempValues[section.key] || []).length === 0
                                                        ? `Select or Search...`
                                                        : ""
                                                }
                                                style={{
                                                    flex: 1,
                                                    border: "none",
                                                    outline: "none",
                                                    fontSize: "14px",
                                                    minWidth: "80px",
                                                }}
                                            />
                                        </div>

                                        {/* DROPDOWN */}
                                        {openDropdown === section.key && (
                                            <div
                                                ref={(el) => (dropdownRefs.current[section.key] = el)}
                                                onClick={(e) => e.stopPropagation()}

                                                style={{
                                                    position: "absolute",
                                                    top: "calc(100% + 4px)",
                                                    left: 0,
                                                    right: 0,
                                                    border: "1px solid #e9ecef",
                                                    borderRadius: "8px",
                                                    maxHeight: "220px",
                                                    overflowY: "auto",
                                                    backgroundColor: "#fff",
                                                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                                    zIndex: 9999,

                                                    // padding: "10px",
                                                }}
                                            >
                                                {/* Filter results */}
                                                {section.data.filter(item =>
                                                    section.renderItem(item).title
                                                        .toLowerCase()
                                                        .includes((tempValues[`${section.key}Search`] || "").toLowerCase())
                                                ).length === 0 ? (

                                                    <div
                                                        style={{
                                                            padding: "16px",
                                                            textAlign: "center",
                                                            color: "#6C757D",
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        No results found
                                                    </div>

                                                ) : (

                                                    section.data
                                                        .filter(item =>
                                                            section.renderItem(item).title
                                                                .toLowerCase()
                                                                .includes((tempValues[`${section.key}Search`] || "").toLowerCase())
                                                        )
                                                        .map(item => {
                                                            const { id, title, subtitle, image } =
                                                                section.renderItem(item);

                                                            const checked = (tempValues[section.key] || []).includes(id);

                                                            return (
                                                                <div
                                                                    key={id}
                                                                    onClick={() => {
                                                                        const list = tempValues[section.key] || [];
                                                                        const updated = checked
                                                                            ? list.filter(x => x !== id)
                                                                            : [...list, id];

                                                                        setTempValues(prev => ({
                                                                            ...prev,
                                                                            [section.key]: updated,
                                                                            [`${section.key}Search`]: "", // reset search
                                                                        }));
                                                                    }}
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "space-between",
                                                                        padding: "8px 12px",
                                                                        cursor: "pointer",
                                                                        fontSize: "14px",
                                                                        backgroundColor: checked ? "#FFFEF0" : "transparent",
                                                                    }}
                                                                >
                                                                    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                                                                        {image && (
                                                                            <img
                                                                                src={image}
                                                                                // onError={(e) => (e.target.src = noImage)}
                                                                                alt={title}
                                                                                style={{
                                                                                    width: 32,
                                                                                    height: 32,
                                                                                    // borderRadius: 6,
                                                                                    // objectFit: "cover",
                                                                                }}
                                                                            />
                                                                        )}

                                                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                                                            <span style={{ color: "#212529", fontWeight: "400", fontFamily: "Montserrat", fontStyle: 'normal', fontSize: '14px', lineHeight: "18px" }}>{title}</span>
                                                                            {subtitle && (
                                                                                <span
                                                                                    style={{
                                                                                        fontSize: 12,
                                                                                        opacity: 0.7,
                                                                                    }}
                                                                                >
                                                                                    {subtitle}
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </div>

                                                                    {checked && (
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                            <path d="M16.6663 5L7.49967 14.1667L3.33301 10" stroke="#6C757D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                        </svg>
                                                                    )}
                                                                </div>
                                                            );
                                                        })
                                                )}
                                            </div>
                                        )}

                                    </div>
                                </div>
                            )}
                            {section.type === "simpleList" && (
                                <div style={{ position: "relative", marginTop: 6 }}>

                                    {/* CHIP CONTAINER */}
                                    <div
                                        style={{
                                            width: "100%",
                                            minHeight: "44px",
                                            borderRadius: "8px",
                                            border: "1px solid #212529",
                                            padding: "6px 10px",
                                            display: "flex",
                                            flexWrap: "wrap",
                                            alignItems: "center",
                                            gap: "6px",
                                            background: "#fff",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => setOpenDropdown(section.key)}
                                    >
                                        {/* Chips */}
                                        {(tempValues[section.key] || []).map((id) => {
                                            const item = section.data.find(i => section.renderItem(i).id === id);
                                            if (!item) return null;

                                            const { title } = section.renderItem(item);

                                            return (
                                                <span
                                                    key={id}
                                                    style={{
                                                        background: "#FFEB00",
                                                        color: "#212529",
                                                        borderRadius: "16px",
                                                        padding: "4px 10px",
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        fontSize: "12px",
                                                        fontWeight: "600",
                                                    }}
                                                >
                                                    {title}
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            const updated = (tempValues[section.key] || []).filter(x => x !== id);

                                                            setTempValues(prev => ({
                                                                ...prev,
                                                                [section.key]: updated
                                                            }));
                                                        }}
                                                        style={{
                                                            background: "none",
                                                            border: "none",
                                                            marginLeft: 6,
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        <X size={14} strokeWidth={3} />
                                                    </button>
                                                </span>
                                            );
                                        })}

                                        {/* NO SEARCH INPUT */}
                                        {tempValues[section.key]?.length === 0 && (
                                            <span style={{ color: "#6C757D", fontSize: 14 }}>Select…</span>
                                        )}
                                    </div>

                                    {/* DROPDOWN */}
                                    {openDropdown === section.key && (
                                        <div
                                            ref={(el) => (dropdownRefs.current[section.key] = el)}
                                            onClick={(e) => e.stopPropagation()}
                                            style={{
                                                position: "absolute",
                                                top: "calc(100% + 4px)",
                                                left: 0,
                                                right: 0,
                                                border: "1px solid #e9ecef",
                                                borderRadius: "8px",
                                                maxHeight: "220px",
                                                overflowY: "auto",
                                                backgroundColor: "#fff",
                                                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                                zIndex: 9999,
                                            }}
                                        >
                                            {section.data.map(item => {
                                                const { id, title, subtitle, image } = section.renderItem(item);
                                                const checked = (tempValues[section.key] || []).includes(id);

                                                return (
                                                    <div
                                                        key={id}
                                                        onClick={() => {
                                                            const list = tempValues[section.key] || [];
                                                            const updated = checked
                                                                ? list.filter(x => x !== id)
                                                                : [...list, id];

                                                            setTempValues(prev => ({
                                                                ...prev,
                                                                [section.key]: updated
                                                            }));
                                                        }}
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "space-between",
                                                            padding: "8px 12px",
                                                            cursor: "pointer",
                                                            fontSize: "14px",
                                                            backgroundColor: checked ? "#FFFEF0" : "transparent",
                                                        }}
                                                    >
                                                        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                                                            {image && (
                                                                <img
                                                                    src={image}
                                                                    alt={title}
                                                                    style={{ width: 32, height: 32 }}
                                                                />
                                                            )}
                                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                                <span style={{ color: "#212529", fontWeight: "400" }}>
                                                                    {title}
                                                                </span>
                                                                {subtitle && (
                                                                    <span style={{ fontSize: 12, opacity: 0.7 }}>
                                                                        {subtitle}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>

                                                        {checked && (
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20">
                                                                <path
                                                                    d="M16.6663 5L7.49967 14.1667L3.33301 10"
                                                                    stroke="#6C757D"
                                                                    strokeWidth="2"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                            </svg>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}

                                </div>
                            )}


                            {/* ------------------------------------------------------- */}
                            {/* RANGE TYPE (Like MSRP Min–Max with "SGD")               */}
                            {/* ------------------------------------------------------- */}

                            {section.type === "range" && (
                                <div style={{ marginTop: 12 }}>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            // width: "100%",
                                            gap: 12
                                        }}
                                    >

                                        {/* MIN BOX – 40% */}
                                        <div
                                            style={{
                                                flex: 1,
                                                minWidth: 0,
                                                border: "1px solid #212529", // thicker border
                                                borderRadius: 12,
                                                display: "flex",
                                                alignItems: "center",
                                                padding: "10px 12px",
                                                background: "#FFFFFF",
                                                boxSizing: "border-box"
                                            }}
                                        >
                                            <span
                                                style={{
                                                    // width: 40,
                                                    color: "#212529",
                                                    fontWeight: 500,
                                                    fontSize: 14,
                                                    fontFamily: "Montserrat",
                                                    borderRight: "1px solid #D9D9D9",
                                                    paddingRight: 8,
                                                    marginRight: 8,
                                                    textAlign: "center"
                                                }}
                                            >
                                                SGD
                                            </span>

                                            <input
                                                type="number"
                                                placeholder="Min"
                                                value={tempValues[`${section.key}_min`] || ""}
                                                onChange={(e) =>{
                                                    const min_value = e.target.value;
                                                    setTempValues(prev => ({
                                                        ...prev,
                                                        [`${section.key}_min`]: min_value
                                                    }))
                                                }}
                                                style={{
                                                    flex: 1,
                                                    border: "none",
                                                    outline: "none",
                                                    fontSize: 14,
                                                    background: "transparent", // FIX
                                                    paddingLeft: 4, // FIX
                                                }}
                                            />
                                        </div>

                                        {/* DASH */}
                                        <span style={{ fontSize: 18, color: "#6C757D" }}>–</span>

                                        {/* MAX BOX – 40% */}
                                        <div
                                            style={{
                                                flex: 1,
                                                minWidth: 0,
                                                border: "1px solid #212529",
                                                borderRadius: 12,
                                                display: "flex",
                                                alignItems: "center",
                                                padding: "10px 12px",
                                                background: "#FFFFFF",
                                                boxSizing: "border-box"
                                            }}
                                        >
                                            <span
                                                style={{
                                                    // width: 40,
                                                    color: "#212529",
                                                    fontWeight: 500,
                                                    fontSize: 14,
                                                    fontFamily: "Montserrat",
                                                    borderRight: "1px solid #D9D9D9",
                                                    paddingRight: 8,
                                                    marginRight: 8,
                                                    textAlign: "center"
                                                }}
                                            >
                                                SGD
                                            </span>

                                            <input
                                                type="number"
                                                placeholder="Max"
                                                value={tempValues[`${section.key}_max`] || ""}
                                                onChange={(e) =>{
                                                    const max_value = e.target.value;
                                                    setTempValues(prev => ({
                                                        ...prev,
                                                        [`${section.key}_max`]: max_value
                                                    }))
                                                }}
                                                style={{
                                                    flex: 1,
                                                    border: "none",
                                                    outline: "none",
                                                    fontSize: 14,
                                                    background: "transparent", // FIX
                                                    paddingLeft: 4, // FIX
                                                }}
                                            />
                                        </div>

                                    </div>
                                </div>
                            )}
                            {section.type === "rangePlain" && (
                                <div style={{ marginTop: 12 }}>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            gap: 12,
                                        }}
                                    >
                                        {/* MIN BOX */}
                                        <div
                                            style={{
                                                flex: 1,
                                                minWidth: 0,
                                                border: "1px solid #212529",
                                                borderRadius: 12,
                                                display: "flex",
                                                alignItems: "center",
                                                padding: "10px 12px",
                                                background: "#FFFFFF",
                                                boxSizing: "border-box",
                                            }}
                                        >
                                            <input
                                                type="number"
                                                placeholder="Min"
                                                value={tempValues[`${section.key}_min`] || ""}
                                                onChange={(e) =>
                                                    setTempValues((prev) => ({
                                                        ...prev,
                                                        [`${section.key}_min`]: e.target.value,
                                                    }))
                                                }
                                                style={{
                                                    width: "100%",
                                                    border: "none",
                                                    outline: "none",
                                                    fontSize: 14,
                                                    background: "transparent",
                                                }}
                                            />
                                        </div>

                                        {/* DASH */}
                                        <span style={{ fontSize: 18, color: "#6C757D" }}>–</span>

                                        {/* MAX BOX */}
                                        <div
                                            style={{
                                                flex: 1,
                                                minWidth: 0,
                                                border: "1px solid #212529",
                                                borderRadius: 12,
                                                display: "flex",
                                                alignItems: "center",
                                                padding: "10px 12px",
                                                background: "#FFFFFF",
                                                boxSizing: "border-box",
                                            }}
                                        >
                                            <input
                                                type="number"
                                                placeholder="Max"
                                                value={tempValues[`${section.key}_max`] || ""}
                                                onChange={(e) =>
                                                    setTempValues((prev) => ({
                                                        ...prev,
                                                        [`${section.key}_max`]: e.target.value,
                                                    }))
                                                }
                                                style={{
                                                    width: "100%",
                                                    border: "none",
                                                    outline: "none",
                                                    fontSize: 14,
                                                    background: "transparent",
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}


                        </div>
                    ))}
                </div>

                {/* Footer */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        gap: "50px",
                        padding: "40px 20px",
                    }}
                >
                    <button
                        onClick={onClear}
                        style={{
                            background: 'none',
                            border: 'none',
                            // color: 'black',
                            // cursor: 'pointer',
                            // fontWeight: '500'
                            width: '140px',
                            color: '#5A6A7D',
                            fontFamily: 'Montserrat',
                            fontSize: '12px',
                            fontStyle: 'normal',
                            lineHeight: 'normal',
                            fontWeight: '600',
                        }}
                    >
                        Clear
                    </button>

                    <div style={{ display: "flex", gap: 8 }}>
                        <button
                            onClick={onClose}
                            style={{
                                background: 'var(--Background-White, #FFF)',
                                // border: 'none',
                                borderRadius: '8px',
                                // cursor: 'pointer',
                                fontWeight: '500',
                                display: 'flex',
                                height: '34px',
                                minWidth: '100px',
                                padding: '10px',
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: '10px',
                                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.10)',
                                border: '1px solid var(--navbar-dropdown-active, #212529)',
                                color: 'var(--navbar-dropdown-active, #212529)',
                                fontFamily: 'Montserrat',
                                fontSize: '12px',
                                fontStyle: 'normal',
                                lineHeight: 'normal',
                                fontWeight: '600',
                            }}
                        >
                            Cancel
                        </button>

                        <button
                            onClick={onApply}
                            style={{
                                display: 'flex',
                                height: '34px',
                                minWidth: '100px',
                                padding: '10px',
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: '10px',
                                background: ' #212529',
                                borderRadius: '8px',
                                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.10)',
                                fontFamily: 'Montserrat',
                                fontSize: '12px',
                                fontStyle: 'normal',
                                lineHeight: 'normal',
                                fontWeight: '600',
                                color: ' #FFF',
                            }}
                        >
                            Filter
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}
